import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import Box from '@mui/material/Box';

import { setScrollPosition } from 'bento-ordering/base/actions/scrollManager';
import { handleMenuItemClick } from 'bento-ordering/menus/actions';
import MenuSectionList from 'bento-ordering/menus/components/MenuSectionList';
import { MENU } from 'bento-ordering/menus/constants/entities';
import MenuSectionHeader from 'components/Menu/MenuSectionHeader';
import { slugify } from 'helpers/slugify';

const MenuSection = ({
  name,
  items,
  shouldLazyLoadMenu,
  isFirst,
  description
}) => {
  const isExpanded = true;
  const dispatch = useDispatch();

  const handleClick = slug => {
    dispatch(setScrollPosition(MENU, window.pageYOffset));
    return dispatch(handleMenuItemClick(slug));
  };

  return (
    <Box id={slugify(name)} mb={1}>
      <MenuSectionHeader
        isFirst={isFirst}
        title={name}
        description={description}
      />
      <MenuSectionList
        menuList={items}
        isExpanded={isExpanded}
        handleClick={handleClick}
        shouldLazyLoadMenu={shouldLazyLoadMenu}
      />
    </Box>
  );
};

MenuSection.defaultProps = {
  description: ''
};

MenuSection.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  items: PropTypes.array,
  isFirst: PropTypes.bool.isRequired,
  shouldLazyLoadMenu: PropTypes.bool
};

export default MenuSection;
